<!-- Evidence Sources Section -->
@if(evidenceSources.length > 0){
<div class="evidence-sources-section">
    @if(showTitle){
    <h3 class="section-title">
        <mat-icon>source</mat-icon>
        {{ title }}
    </h3>
    <!-- <h4>Context Sources:</h4> -->
    }
    <div class="evidence-capsules">
        @for(evidence of evidenceSources; track evidence.url || evidence.source){
        <div class="evidence-capsule"
             [matTooltip]="getEvidenceTooltip(evidence)"
             matTooltipPosition="above"
             matTooltipClass="evidence-tooltip"
             (click)="openSourceLink(evidence.url || '')"
             [title]="'Click to view source: ' + evidence.url">
            {{ evidence.source }}
        </div>
        }
    </div>
</div>
}
